$(function() {
  var $header = $(".feature_image .header");
  
  $(document).ready(function() {
      $("img").unveil();
  });

  
  $(".product_slider img").unveil(200);
  $(".thumbnail img, .cart_page_image img").unveil(400, function() {
    $(this).load(function() {
      this.style.opacity = 1;
    });
  });

  

  if ($(window).width() >= 768) {
    
      if($header.length && !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        var s = skrollr.init({forceHeight: false});
        $(".featured_products").next(".slide").waypoint(function() {
          window.dispatchEvent(new Event('resize'));
        });
      }
    
    $("#featured_links").waypoint(function() {
      $(this).find(".column, .columns").addClass("animated ");
    }, { offset: '80%' });

    
      $("#pagecontent").waypoint(function(direction) {
        $header.toggleClass('is-absolute');
        $header.removeClass('fadeIn');
        $header.addClass('delay-0s');
        
        if($(window).width() >= 768) {
          if(!$header.hasClass('is-absolute')) {
            $('.logo img', $header).attr('src', $('.logo img').data('src'));
          } else {
            $('.logo img', $header).attr('src', $('.logo img').data('src-home'));
          }
        } 
        $header.toggleClass('fadeInDown');
      });
    

    $(".animate_right").waypoint(function() {
      $(this).addClass("animated fadeInRight");
    }, { offset: '70%' });
    $(".animate_left").waypoint(function() {
      $(this).addClass("animated fadeInLeft");
    }, { offset: '70%' });
    $(".animate_up").waypoint(function() {
      $(this).addClass("animated fadeInUp");
    }, { offset: '70%' });
    $(".animate_down").waypoint(function() {
      $(this).addClass("animated fadeInDown");
    }, { offset: '70%' });    
  }
  
  
    $(window).on('load', function() {
      $('#nav').mmenu({
        
          searchfield : {
            add: true,
            search: true,
            noResults: '<a href="/search?q=" class="search_link">' + "Advanced Search \u0026#8594;" + '</a>'
          },
        
       classes: "mm-dark",
       offCanvas: { pageSelector: "#content_wrapper" },
      });

    });


  $('.search_link').on("click", function(){
    $(this).attr("href", $(this).attr("href") + $(".mm-search input").val());  
  })

  if ($('html').hasClass('ie')) {
    $('.icon-cart').on("click", function() { window.location = '/cart'; return false; });
  } else {
    new Share(".share-button", {
      ui: {
        flyout: "bottom left",
        button_font: false,
        button_text: "Share"
      },
      networks: {
        facebook: {
          load_sdk: false
        },
        email: {
          description: escape($('meta[name=description]').attr("content")) + " - " + document.URL
        }
      }
    });  
  
    
      $('#cart').mmenu({
        offCanvas: { position: 'right', zposition : "front", pageSelector: "#content_wrapper" },
        classes: "mm-dark"
      });
    
    $('.icon-cart, .icon-menu').on("click", function(e) { 
      $('#search').hide();
    });
  }

  $('.slider').flexslider({controlNav: false, animation: "fade" });
  
  $('.product_slider').flexslider({
    startAt: parseInt($('.featured_image', $(this)).data('index'), 10),  
    touch: true,
    pauseOnHover: true,
    controlNav: "thumbnails",
    directionNav: true,
    
      animation: "slide",
    
    slideshowSpeed: 10*1000
  });

  
    if($('.product_slider img').data("index") == 0) { $('.product_slider .flex-direction-nav').hide() }
  

  $(document).on("click", '.continue, .edit_cart, .mm-opened #header', function(e) {
    $('#cart').trigger("close");
    $('#nav').trigger("close");
    e.stopPropagation();
    e.preventDefault();
    return false;
  });

  $('#search-toggle, .search-close').on('click', function(e) {
    $('.search-close, .search-submit').css('padding-top', $('.header').height() + 50 + 'px')
    if($('#search').is(":visible") && $(window).scrollTop() == 0) {
      

      if($('body.feature_image').length) {
        $('.logo img').attr('src', $('.logo img').data('src-home'));
      }
    } else {
      $header.addClass('header_bar');
      $('.logo img').attr('src', $('.logo img').data('src'));
    }

    if($('#search').hasClass("fadeIn")) {
      $('#search').removeClass("fadeIn").hide();
    } else {
      $('#search').show().addClass("fadeIn").find('input').focus();
    }
    
    e.stopPropagation();
    e.preventDefault();
  })

  $(".icon-search").on('click', function(e) { $(this).parent('form').submit(); });

  $('.lightbox').fancybox();
  
  if ($(window).width() >= 959) {
    $('.header_bar .dropdown').css({"top": $('.header').height()});
    $('.thumbnail').hover(function(){ $('.quick_shop', this).show(); }, function(){ $('.quick_shop', this).hide(); })
    var modal_width = '870px';
    if($(window).width() >= 1200 || $('html').hasClass('ie')) {
      modal_width = '1110px'
    }
    $(".quick_shop").fancybox({
      width: modal_width,
      height: 'auto',
      autoSize: false,
      padding: 10,
      beforeShow: function(e) {
        var $gallery = $('.' + $(this.element).data('gallery'));
        var $product = $(this.element).data("fancybox-href");        
        $("img", $gallery).unveil();
        $gallery.flexslider({
          touch: false,
          pauseOnHover: true,
          controlNav: "thumbnails",
          directionNav: true,
          
            animation: "slide",
          
          slideshowSpeed: 10*1000
        });
        
          $gallery.find(".fancybox:not(:first):not(:last)").fancybox({padding: 0, wrapCSS: 'gallery'});
          if($gallery.find('img').data("index") == 0) { $gallery.find('.flex-direction-nav').hide() }
        
      }
    });
  } 

   $('.mm-search input').keypress(function(e) {
    if(e.which == 13) {
      window.location = '/search?q=' + $(this).val();
    }
  });

  
    $(".product_slider .fancybox:not(:first):not(:last)").fancybox({padding: 0, wrapCSS: 'gallery'});
  

  

    

  $('#tag_filter').change(function() { window.location = $('#tag_filter option:selected').val(); });  
  $("#cart_form input[type='number']").change(function() {$("#cart_form").submit(); });

  

  Shopify.queryParams = {};
  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }

  var tabs = $('ul.tabs');
  tabs.each(function(i) {
    var tab = $(this).find('> li > a');
    tab.click(function(e) {
      var contentLocation = $(this).attr('href');
      if(contentLocation.charAt(0)=="#") {
        e.preventDefault();
        tab.removeClass('active');
        $(this).addClass('active');
        $(this).parents('ul.tabs').next().find(contentLocation).show().css({'display': 'block'}).addClass('active').siblings().hide().removeClass('active');
      }
    });
  });

  $('.toggle').click(function() {
    if ($(window).width() <= 767) { 
      var $toggle = $(this);
      if($toggle.next('ul').is(':visible')) {
        $toggle.next('ul').hide();
        $toggle.children('span').html('+');
      } else {
        $toggle.next('ul').show();
        $toggle.children('span').html('-');
      }
    }
  });

  var $contact_form = $('.newsletter .contact-form');
  $contact_form.each(function() {
    var $cf = $(this);
    $cf.on("submit", function (e) {
      
        $.ajax({
            type: $cf.attr('method'),
            url: $cf.attr('action'),
            data: $cf.serialize(),
            success: function (data) {
              $contact_form.fadeOut("slow", function(){
                $cf.prev('.message').html("Thank you for joining our mailing list!");
              });
            }
        });
        e.preventDefault();
      
      setTimeout($.fancybox.close, 2000);
    });
  });

  var $notify_form = $('.notify_form .contact-form');
  $notify_form.each(function() {
    var $nf = $(this);
    $nf.on("submit", function (e) {
      if($nf.find('.notify_email').val() != "") {
        $.ajax({
            type: $nf.attr('method'),
            url: $nf.attr('action'),
            data: $nf.serialize(),
            success: function (data) {
              $notify_form.fadeOut("slow", function(){
                $nf.prev('.message').html("Thanks! We will notify you when this product becomes available!");
              });
            }
        });
      } else {
        $nf.prev('.message').html("Please provide a valid email address.");
      }  
      e.preventDefault();
    });
  });  

  

  $('.maps').click(function () {
    $('.maps iframe').css("pointer-events", "auto");
  });

  
    $(function() {
      var $target = $("#instafeed");
      $target.instagramLite({
        clientID: $target.data('client-id'),
        urls: true,
        videos: true,
        limit: $target.data('count'),
        error: function(errorCode, errorMessage) {
          if(errorCode && errorMessage) {
            alert(errorCode +': '+ errorMessage);
          } 
        }
        });
      });
    


  /*============================================================================
    Start of cart-related functionality
  ==============================================================================*/
  function ajaxSubmitCart() {
    $cart = $("#cart");
    $.ajax({
      url: '/cart.js',
      dataType: 'json',
      type: 'post',
      data: $cart.serialize(),
      success: function (data) {
        refreshCart(data);
      }
    });
  }

  function refreshCart(cart) {
    $cartBtn = $(".icon-cart");
    if ($cartBtn && $cartBtn.size()) {
      var value = $cartBtn.text() || '0';
      var cart_items_html = "";
      var $cart = $("#cart ul");
      
      $cartBtn.text(value.replace(/[0-9]+/,cart.item_count));
      $cart.find('li:not(:first)').remove();

      if (cart.item_count == 0) {
        $cart.append('<li class="empty_cart">Your Cart is Empty</li>');
      } else {
        $.each(cart.items, function(index, item) {
          cart_items_html += '<li class="cart_item">' +
            '<p class="mm-counter">' +
              '<span class="ss-icon minus">&#x002D;</span>' +
              '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity +'" />' +
              '<span class="ss-icon plus">&#x002B;</span>' +
            '</p>' +
            '<a href="' + item.url +'">';
          if (item.image) {
            cart_items_html += '<div class="cart_image">' +
                '<img src="' + item.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' +
              '</div>';
          }
          cart_items_html += '<div class="item_title">' + item.title +'</div>' +
              '<strong class="price">' + Shopify.formatMoney(item.price, $cart.data('money-format')) + '</strong>' +
            '</a>' +
          '</li>';
        });

        cart_items_html += '<li class="mm-label">' +
            '<p class="mm-counter">' + Shopify.formatMoney(cart.total_price, $cart.data('money-format')) + '</p>' +
            '<a href="/cart">' +
              '<strong>Subtotal</strong>' +
            '</a>' +
          '</li>' +
          '<li class="mm-subtitle clearfix">';

          

          

          cart_items_html += '<input type="submit" class="action_button right" value="Checkout" />' +
            '<a href="javascript:void(0)" class="action_button edit_cart right">Continue</a>' +
          '</li>';

        $cart.append(cart_items_html);
        $cart.find('li.cart_item:last').addClass('last_cart_item');

        
      }
    }
  }

  $(document).on("change", "#cart input.quantity", function() { 
    ajaxSubmitCart();
  });

  $(document).on("click", ".minus", function() { 
    var quantity = parseInt($(this).next("input").val()); 
    quantity -= 1;
    $(this).next("input").attr("value", quantity);
    if (quantity == 0) {
      $(this).closest('li.cart_item').addClass('animated fadeOutUp')
      setTimeout(ajaxSubmitCart, 500);
    } else {
      ajaxSubmitCart();
    }
  });
  $(document).on("click", ".plus", function() { 
    var quantity = parseInt($(this).prev("input").val()); 
    quantity += 1;
    $(this).prev("input").attr("value", quantity);
    ajaxSubmitCart();
  });

  
    $(".product_form").submit(function(e) {
      e.preventDefault();
      var $addToCartForm = $(this);  
      var $addToCartBtn = $addToCartForm.find('.add_to_cart');

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass("zoomIn").addClass('animated zoomOut');
        },
        success: function(itemData) {
          $addToCartBtn.find('span').text("Added").removeClass('zoomOut').addClass('fadeIn');

          window.setTimeout(function(){
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('span').addClass("fadeOut").text($addToCartBtn.data('label')).removeClass('fadeIn').removeClass("fadeOut").addClass('zoomIn');
          }, 1000);

          $.getJSON("/cart.js", function(cart) {
            refreshCart(cart);
            window.setTimeout(function(){ $.fancybox.close(); $('.cart-button').click(); }, 500);
          });    
        },
        error: function(XMLHttpRequest) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
          $('.warning').remove();

          var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
          $addToCartForm.after(warning);
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text("Add to Cart").removeClass('zoomOut').addClass('zoomIn');
        }
      });

      return false;
    });
  

  selectCallback = function(variant, selector) {
    var $product = $('.product-' + selector.product.id);
    var $notify_form = $('.notify-form-' + selector.product.id);
    var $productForm = $('form.product_form', $product);

    if (variant && variant.featured_image && $product.is(":visible")) {
      var $sliders = $('.product_gallery', $product);
      $sliders.each(function() {
        var $slider = $(this);
        if ($slider.is(":visible")) {
          $slider.flexslider($('[data-image-id="' + variant.featured_image.id + '"]').data('index'));
        }
      });
    }

    if (variant) {
      $('.sku span', $product).text(variant.sku);
      $(".notify_form_message", $product).attr("value", $(".notify_form_message", $product).data('body') + " - " + variant.title);

      
    }

    if (variant && variant.available == true) {
      if(variant.price < variant.compare_at_price){
        $('.was_price', $product).html(Shopify.formatMoney(variant.compare_at_price, $productForm.data('money-format')))        
      } else {
        $('.was_price', $product).text('')
      } 

      if (variant.inventory_management && variant.inventory_quantity > 0) {
        
        if(variant.inventory_policy == "deny") {
          $('.quantity', $product).attr('max', variant.inventory_quantity);
        }
      } else {
        $('.items_left', $product).text('');
        $('.quantity', $product).removeAttr('max');
      }

      $('.sold_out', $product).text('');
      if (variant.price > 0) {
        $('.current_price', $product).html(Shopify.formatMoney(variant.price, $productForm.data('money-format')));
      } else {
        $('.current_price', $product).html("See Price List");
      }      
      $('.add_to_cart', $product).removeClass('disabled').removeAttr('disabled').find('span').text($('.add_to_cart', $product).data('label'));
      $notify_form.hide();
    } else {
      var message = variant ? "Sold Out" : "Unavailable";
      $('.was_price', $product).text('');
      $('.current_price', $product).text('');
      $('.items_left', $product).text('');
      $('.quantity', $product).removeAttr('max');
      $('.sold_out', $product).text(message);
      $('.add_to_cart', $product).addClass('disabled').attr('disabled', 'disabled').find('span').text(message); 
      $notify_form.fadeIn();
    }
    
    
  };          
});

function htmlEncode(value){ 
    if (value) {
        return $('<div/>').text(value).html(); 
    } else {
        return '';
    }
}
